import { action } from 'utils/actions'

export const GRID_LOAD_EVENT_GROUP = 'GRID_LOAD_EVENT_GROUP'
export const GRID_LOAD_EVENT_GROUP_DATA = 'GRID_LOAD_EVENT_GROUP_DATA'
export const GRID_CREATE_DEAL = 'GRID_CREATE_DEAL'
export const GRID_CREATE_TIME_DEALS = 'GRID_CREATE_TIME_DEALS'
export const GRID_CREATE_DATE_DEALS = 'GRID_CREATE_DATE_DEALS'
export const GRID_REMOVE_DEAL = 'GRID_REMOVE_DEAL'
export const GRID_CREATE_TICKET = 'GRID_CREATE_TICKET'
export const GRID_EDIT_TICKET = 'GRID_EDIT_TICKET'
export const GRID_REMOVE_TICKET = 'GRID_REMOVE_TICKET'
export const GRID_CREATE_TIME = 'GRID_CREATE_TIME'
export const GRID_DATE_PICKER_SELECT_DATES = 'GRID_DATE_PICKER_SELECT_DATES'
export const GRID_DATE_PICKER_CONFIRM_DATES = 'GRID_DATE_PICKER_CONFIRM_DATES'
export const GRID_REMOVE_DATE = 'GRID_REMOVE_DATE'
export const GRID_REMOVE_TIME = 'GRID_REMOVE_TIME'
export const GRID_SAVE = 'GRID_SAVE'
export const GRID_CANCEL = 'GRID_CANCEL'
export const GRID_SET_CURRENT_EDITING_SELLABLE_ITEM = 'GRID_SET_CURRENT_EDITING_SELLABLE_ITEM'
export const GRID_SET_OPERATION_ERROR = 'GRID_SET_OPERATION_ERROR'

export const gridLoadEventGroup = (eventGroupId) => action(GRID_LOAD_EVENT_GROUP, { eventGroupId })

export const gridLoadEventGroupData = (deals, sellableItems) =>
  action(GRID_LOAD_EVENT_GROUP_DATA, { deals, sellableItems })

export const gridCreateDeal = (dateId, timeId, sellableItemId) =>
  action(GRID_CREATE_DEAL, { dateId, timeId, sellableItemId })

export const gridCreateTimeDeals = (timeId, sellableItemId) =>
  action(GRID_CREATE_TIME_DEALS, { timeId, sellableItemId })

export const gridCreateDateDeals = (dateId, sellableItemId) =>
  action(GRID_CREATE_DATE_DEALS, { dateId, sellableItemId })

export const gridRemoveDeal = (dateId, timeId, dealId) => action(GRID_REMOVE_DEAL, { dateId, timeId, dealId })

export const gridCreateTicket = (eventGroupId, values) => action(GRID_CREATE_TICKET, { eventGroupId, values })

export const gridEditTicket = (sellableItemId, values) => action(GRID_EDIT_TICKET, { sellableItemId, values })

export const gridRemoveTicket = (sellableItemId) => action(GRID_REMOVE_TICKET, { sellableItemId })

export const gridCreateTime = (hour, minute) => action(GRID_CREATE_TIME, { hour, minute })

export const gridDatePickerSelectDates = (dates) => action(GRID_DATE_PICKER_SELECT_DATES, { dates })

export const gridDatePickerConfirmDates = () => action(GRID_DATE_PICKER_CONFIRM_DATES)

export const gridRemoveDate = dateId => action(GRID_REMOVE_DATE, { dateId })

export const gridRemoveTime = timeId => action(GRID_REMOVE_TIME, { timeId })

export const gridSave = eventGroupId => action(GRID_SAVE, { eventGroupId })

export const gridCancel = eventGroupId => action(GRID_CANCEL, { eventGroupId })

export const gridSetCurrentEditingSellableItem = sellableItemId =>
  action(GRID_SET_CURRENT_EDITING_SELLABLE_ITEM, { sellableItemId })

export const gridSetOperationError = error => action(GRID_SET_OPERATION_ERROR, { error })



/** WEBPACK FOOTER **
 ** ./src/actions/grid/grid-actions.js
 **/